import React from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import { IMAGE_TYPE, IMAGE_MODE } from '../../util/enums';
import InstanceSizeSelector from './InstanceSizeSelector';
import NodeStackField from './NodeStackField';

const inputGroupStyle = { display: 'flex', flexDirection: 'row', gap: '16px', marginBottom: '16px', alignItems: 'flex-start' };

/**
 * Standard compute node group fields shared across providers.
 * Renders: NodeStackField (multi-image), InstanceSizeSelector, Image Type (multi-image), Count.
 * Provider-specific extras (e.g. GCP accelerators) rendered via `children`.
 */
export default function ComputeNodeGroupFields({
    group, index, updateGroup,
    provider, imageMode, maxCount = 250,
    onInstanceChange, allowedInstanceIds, disableStackFields, disabled,
    children,
}) {
    const isMultiImage = (imageMode || IMAGE_MODE.UNIFIED) === IMAGE_MODE.MULTI_IMAGE;

    return (
        <>
            <div style={inputGroupStyle}>
                {isMultiImage && (
                    <NodeStackField
                        provider={provider}
                        value={group.group_node_prefix || group.image_name || ''}
                        onChange={(prefix) => updateGroup(index, group.group_node_prefix !== undefined ? 'group_node_prefix' : 'image_name', prefix)}
                        disabled={disableStackFields}
                    />
                )}
                <InstanceSizeSelector
                    provider={provider}
                    value={group.instance_id || ''}
                    onChange={onInstanceChange
                        ? (instanceId) => onInstanceChange(index, instanceId)
                        : (instanceId) => updateGroup(index, 'instance_id', instanceId)
                    }
                    allowedInstanceIds={allowedInstanceIds}
                    label="Instance Type"
                    disabled={disabled}
                />
                {isMultiImage && (
                    <TextField
                        select label="Image Type" variant="outlined"
                        value={group.image_type || IMAGE_TYPE.HEIDI_STACK}
                        onChange={(e) => updateGroup(index, 'image_type', e.target.value)}
                        style={{ width: '180px' }}
                        disabled={disableStackFields}
                    >
                        <MenuItem value={IMAGE_TYPE.HEIDI_STACK}>Heidi Stack</MenuItem>
                        <MenuItem value={IMAGE_TYPE.CUSTOM_STACK}>Custom Stack</MenuItem>
                    </TextField>
                )}
                <TextField
                    label="Count" type="number"
                    value={group.count != null ? group.count : 1}
                    onChange={(e) => {
                        const val = parseInt(e.target.value, 10);
                        if (!isNaN(val) && val >= 0) updateGroup(index, 'count', val);
                    }}
                    variant="outlined"
                    InputProps={{ inputProps: { min: 0, max: maxCount } }}
                    disabled={disabled}
                    style={{ width: '120px' }}
                />
            </div>
            {children}
        </>
    );
}
